import { HttpContextToken } from '@angular/common/http';

export const PASS_ACCEPT_HEADER = new HttpContextToken<boolean>(() => true);